<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销售组织">
            <a-select placeholder="请选择销售组织" :options="this.organizationOptions" v-decorator="['organizationId',{initialValue:data.organizationId,rules: [{ required: true, message: '请选择销售组织'}]}]"></a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客户类别">
            <a-select placeholder="若不指定，则该发送给组织下所有类别的经销商" :options="this.dealerTypeOptions" v-decorator="['dealerType',{initialValue:data.dealerType,rules: [{ required: false, message: '请选择客户类别'}]}]"></a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label>
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";

const defaultData = {
  id: 0,
  announcementId: 0,
  organizationId: undefined,
  dealerType: undefined
};
export default {
  name: "hp-manager-page-announcementScope-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      organizationOptions: [],
      dealerTypeOptions: []
    };
  },

  async mounted() {
    this.data = exzends(defaultData);
    this.getOrganizationOptions();
    this.getDealerTypeOptions();
    this.data.announcementId = this.params.announcementId;
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async getOrganizationOptions() {
      let orgList = await api.GetOrganizationSelect();
      if (orgList) {
        orgList.forEach(a => {
          this.organizationOptions.push({
            label: a.text,
            value: a.value
          });
        });
      }
    },
    async getDealerTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 3 });
      if (dictionary) {
        dictionary.forEach(a => {
          this.dealerTypeOptions.push({
            label: a.text,
            value: a.value,
            disabled: a.disabled
          });
        });
      }
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        announcementId: this.data.announcementId,
        organizationId: parseInt(value.organizationId),
        dealerType: parseInt(value.dealerType)
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.CreateOrUpdateAnnouncementScope(requestData);
        if (this.params.id > 0) {
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Information/Announcement/AddScope.vue